var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"piechart"},[_c('div',{staticClass:"text-xs-center"},[_c('h5',[_vm._v(_vm._s(_vm.title))])]),_c('ve-pie',{attrs:{"data":_vm.chartData,"toolbox":_vm.toolbox}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }